/** Languages offered for a Keepo's <html lang>, as ISO codes (language, or language-REGION). */
export const SEO_LANGUAGES: { code: string; name: string }[] = [
  { code: "pt-BR", name: "Português (Brasil)" },
  { code: "pt-PT", name: "Português (Portugal)" },
  { code: "en", name: "English" },
  { code: "en-US", name: "English (United States)" },
  { code: "en-GB", name: "English (United Kingdom)" },
  { code: "es", name: "Español" },
  { code: "fr", name: "Français" },
  { code: "de", name: "Deutsch" },
  { code: "it", name: "Italiano" },
];

export const DEFAULT_SEO_LANGUAGE = "pt-BR";
